<template>
  <RexDataTable
    :loading="loadingEndPoint"
    :headers="headers"
    :items="items"
    :search="true"
    :title="titleEnd"
    :highlight="color"
    width="100%"
    height="21em"
    :total="itemsTotal"
    :pageNo="currentPage"
    @onPageChange="onEndPage"
    @onSearchChange="onEndSearch"
    @updateSearch="onEndSort"
    @redirectInput="redirectEndInput"
    @onClear="clearSearchEnd"
  />
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
import RexDataTable from '@/rex-components/rex-DataTable.vue';
import debounce from 'lodash/debounce';
import { MetricType, Capability, ScopeType } from '@/utils/enums/metricType';
import { EndpointOverviewHeader } from '@/utils/enums/headerType';
import { SortOrder } from '@/utils/enums/sortOrder';

export default {
  name: 'EndpointOverview',
  components: {
    RexDataTable,
  },
  data: function () {
    return {
      titleEnd: this.$t('endpoint'),
      loadingEndPoint: true,
      metricEnd: MetricType.ERROR,
      orderEnd: SortOrder.DES,
      keywordEnd: '',
      pageNumEnd: 1,
      pageSizeEnd: 10,
      currentPage: 1,
      pageSize: 10,
      itemsTotal: 0,
      color: 'secondary',
      search: true,
      headers: [
        {
          key: EndpointOverviewHeader.ENDPOINT_NAME,
          name: this.$t('name'),
          width: '40%',
          sortable: false,
        },
        {
          key: EndpointOverviewHeader.ERROR,
          name: this.$t('errorsPercentage'),
          width: '20%',
          dataType: 'float',
          sortable: true,
          defaultSortBy: true,
          defaultOrder: SortOrder.DES,
        },
        {
          key: EndpointOverviewHeader.RESP,
          width: '30%',
          name: this.$t('responseTimeInMs'),
          dataType: 'float',
          sortable: true,
        },
        {
          key: EndpointOverviewHeader.CPM,
          name: this.$t('callsPerMin'),
          width: '15%',
          dataType: 'float',
          sortable: true,
        },
      ],
      items: [],
      durationTime: {
        end: '2021-03-16',
        start: '2021-03-09',
        step: 'DAY',
      },
      selectedValue: {
        endpoint: {},
      },
      appSearch: '',
      endPointSearch: '',
    };
  },
  computed: {
    ...mapState('apmState/apmCommonState', ['endpoints']),
    ...mapGetters('globalState/settings', ['getDurationTime']),
    ...mapState('homeState', ['endpointData', 'endpointDataTotal']),
  },
  watch: {
    getDurationTime: function (newValue, oldValue) {
      this.loadEndpoint();
    },
  },
  mounted: function () {
    this.loadEndpoint();
  },
  methods: {
    ...mapActions('apmState/apmCommonState', [
      'selectEndpoint',
      'selectService',
    ]),
    ...mapActions('homeState', ['GET_ENDPOINT_META']),
    async loadEndpoint(metric, order, keyword, pageNum, pageSize) {
      const params = {
        condition: {
          keyword: this.keywordEnd,
          filterCondition: {
            scope: 'Endpoint',
            metricType: this.metricEnd,
            order: this.orderEnd,
          },
          pagination: {
            pageNum: this.pageNumEnd,
            pageSize: this.pageSizeEnd,
            needTotal: true,
          },
          duration: this.getDurationTime,
          serviceReq: {
            capability: Capability.APM,
          },
        },
      };
      try {
        await this.GET_ENDPOINT_META(params);
      } catch (error) {
        console.log('error', error);
      } finally {
        this.loadingEndPoint = false;
      }
      this.items = this.endpointData;
      this.itemsTotal = this.endpointDataTotal;
      //console.log('loadEndpoint', this.endpointData);
    },
    onOptionSelect() {
      // Call action to set current endpoint
      this.selectEndpoint(this.selectedValue);
    },
    handleSearch: debounce(function () {
      this.loadService();
    }, 300),
    onEndSearch(data) {
      this.keywordEnd = data;
      if (data.length > 2 || data.length === 0) {
        this.pageNumEnd = 1;
        this.loadEndpoint();
      }
      this.handleSearch();
    },
    onEndPage(state) {
      this.pageNumEnd = state.pageNo;
      this.pageSizeEnd = state.pageSize;
      this.loadEndpoint();
      //console.log('onEndPage', state);
    },
    onEndSort(data) {
      this.orderEnd = data.order;
      switch (data.header) {
        case EndpointOverviewHeader.RESP:
          this.metricEnd = MetricType.RESP;
          break;
        case EndpointOverviewHeader.ERROR:
          this.metricEnd = MetricType.ERROR;
          break;
        case EndpointOverviewHeader.CPM:
          this.metricEnd = MetricType.CALLS;
          break;
      }
      this.loadEndpoint();
    },
    redirectEndInput(option) {
      let item = {
        key: option.endPointID,
        label: option.endPointName,
      };
      let selectedValue = {
        endpoint: item,
      };
      this.selectEndpoint(selectedValue);
      this.$router.push({
        name: 'endpointGraph',
      });
    },
    clearSearchEnd() {
      this.keywordEnd = '';
      this.pageNumEnd = 1;
      this.loadEndpoint();
    },
  },
};
</script>
<style lang="scss" scoped></style>
